<template>
    <div class="dm-spinner-wrapper my-10 mx-10">
        <div class="spinner spinner-track spinner-info spinner-lg"></div>
    </div>
</template>
